export default "__VITE_ASSET__B3e_CcGE__"